import React, { useEffect, useState } from 'react';
import useScreenSize from 'hooks/size';
import { Link } from 'react-router-dom';
import styles from './breadcrumbs.module.css';

const Breadcrumbs = ({ crumbs }) => {
  const { isMobile } = useScreenSize();

  const [current_page, setCurrentPage] = useState('');
  const [crumb_path, setCrumbPath] = useState('');

  useEffect(() => {
    if (!crumbs || !Array.isArray(crumbs) || crumbs.length === 0) {
      setCurrentPage('Home');
      return;
    }
    const last_crumb = crumbs[crumbs.length - 1];
    setCurrentPage(last_crumb.title);
    setCrumbPath(crumbs.slice(0, crumbs.length - 1));
  }, [crumbs]);

  return (
    <>
      {!isMobile ? (
        <div className={styles.breadcrumbs}>
          <div className={styles.main}>{current_page}</div>
          <div className={styles.path}>
            {crumb_path.length ? (
              crumb_path.map((crumb, index) => (
                <Link to={crumb.path} key={index}>
                  {crumb.title}
                </Link>
              ))
            ) : (
              <Link to={'/'} key={`link-home`}>
                Home
              </Link>
            )}
          </div>
        </div>
      ) : (
        <span style={{ color: '#000' }}>{current_page}</span>
      )}
    </>
  );
};

export default Breadcrumbs;
